import { createBrowserDb } from '@ctrl/db';

/**
 * The admin's Supabase client.
 *
 * The SPA talks to PostgREST directly — there is no server of ours in between —
 * so the staff JWT and flat claim-RLS are the enforcement boundary for every
 * read and write made here. Anything that needs the service-role key or a
 * Cloudflare binding goes to the admin API instead (see ./admin-api.ts).
 */
export const supabase = createBrowserDb(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
